import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';

export default function BackDrop({ show, ...props }) {
  return <Backdrop open={show} {...props} />;
}
